import React, {Component} from "react";
import {Grid, Row, Col, FormGroup, FormControl, InputGroup, ControlLabel, Glyphicon,Well} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import apiClient from "api/client";
import {css} from "@emotion/core";
import {ScaleLoader} from 'react-spinners';
import {Redirect} from "react-router";
import Button from "../../components/CustomButton/CustomButton";
import ModalSave from "../../components/CustomModals/ModalSave";
import 'react-dual-listbox/lib/react-dual-listbox.css';
import {userActions} from "../../authentication/_actions";
import Switch from "components/CustomSwitch";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import {DualListBoxPackageSvodSeries} from "../../components/DualListBox/DualListBoxPackageSvodSeries";
import {DualListBoxPackageSvodMovies} from "../../components/DualListBox/DualListBoxPackageSvodMovies";
import Select from "react-select";
import ImageUpload from "../../components/ImageUpload/ImageUpload";
import NotificationSystem from "react-notification-system";
import {style} from "../../variables/Variables";
import {DropDownContentProviders} from "../../components/CustomDropDown/DropDownContentProviders";
import {DropDownSvodPriceList} from "../../components/CustomDropDown/DropDownSvodPriceList";
import {DropDownCountries} from "../../components/CustomDropDown/DropDownCountries";

const override = css`
    position: fixed;
    left: 50%;
    top: 35%;
    display: block;
    z-index: 1000;
    height: 31px;
    width: 100px;
    `;

const packageType = [
    {value: 'ALL', label: 'Both Movies & Series'},
    {value: 'SELECTED', label: 'Selected Movies & Series'},
    {value: 'MOVIES', label: 'Only Movies'},
    {value: 'SERIES', label: 'Only Series'}
];

const adminArray = ['super-admin', 'admin']

const DeviceTypeOptions = [
    {value: 'android_mobile', label: 'Android'},
    {value: 'android_tv', label: 'Android TV'},
    {value: 'ios_mobile', label: 'iOS'},
    {value: 'roku', label: 'Roku'},
    {value: 'web', label: 'Web'},
];
class EditPackagesSvod extends Component {

    constructor(props) {
        super(props);
        this.state = {

            loading: false,

            redirect: false,
            vodPackageRedirect: false,

            back_button_text: "Cancel",
            showSaveModal: false,

            svodPackageObject: [],

            vodpackage_id: 0,
            vodpackage_name_short: null,
            vodpackage_name_long: null,
            vodpackage_description: null,
            vodpackage_status: false,
            vodpackage_price: 0.0,
            vodpackage_is_adult: false,
            vodpackage_display_while_inactive: false,
            vodpackage_billing_code: null,
            vodpackage_subscription_url: null,
            vodpackage_trial: null,

            vodpackage_image: null,
            vodpackage_image_temp: false,
            vodpackage_image_folder_temp: "",

            vodpackage_inactive_image_temp: false,
            vodpackage_inactive_image: null,
            vodpackage_inactive_image_folder_temp: "",

            statusSwitch: false,
            expirySwitch: false,
            adultSwitch: false,
            trialSwitch: false,
            creditCardSwitch: false,
            codeSwitch: false,
            accountSwitch: false,

            assignedSvodInPackage: [],
            assignedSeriesInPackage: [],

            vodpackage_type: null,

            vodpackage_duration: null,

            newPackage: true,

            _notificationSystem: null,

            vodpackage_content_provider: null,
            current_user: null,
            user_content_provider: null,
            custom_data: null,

            vodpackage_credit_card_status: false,
            vodpackage_credit_card_product_id: null,
            vodpackage_credit_card_control_text: null,
            vodpackage_credit_card_help_url: null,

            vodpackage_code_status: false,
            vodpackage_code_control_text: null,
            vodpackage_code_help_url: null,

            vodpackage_account_status: false,
            vodpackage_account_control_text: null,
            vodpackage_account_help_url: null,

            vod_pgroups: [],
            vod_pgroups_cards: null,
            vod_pgroups_codes: null,

            countryBlockSwitch: false,
            addAllCountriesInCountryBlock: false,
            vodpackage_country_block_countries: null,

            accessVisibilitySwitch: false,
            vodpackage_device_type_visibility: null,

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSvodPackageChannelChange = this.handleSvodPackageChannelChange.bind(this);
        this.handleSvodPackageSeriesChange = this.handleSvodPackageSeriesChange.bind(this);
        this.handleChildContentProviderSelect = this.handleChildContentProviderSelect.bind(this);
        this.handleChildImageSelect = this.handleChildImageSelect.bind(this);

        this.handleChildSVodPriceGroupsCodesSelected = this.handleChildSVodPriceGroupsCodesSelected.bind(this);
        this.handleChildSVodPriceGroupsCreditCardSelected = this.handleChildSVodPriceGroupsCreditCardSelected.bind(this);
        this.handleChildCountryBlockSelect = this.handleChildCountryBlockSelect.bind(this);
        this.handleDeviceTypeChange = this.handleDeviceTypeChange.bind(this);

    }

    handleDeviceTypeChange = (data) => {

        console.log(`Option selected:`, data);

        let deviceTypeIds = []

        for (let i = 0; i < data.length; i++) {
            deviceTypeIds.push(data[i].value)
        }

        this.setState({
            vodpackage_device_type_visibility: data === null ? 0 : deviceTypeIds
        });

    }

    handleChildSVodPriceGroupsCreditCardSelected(data) {

        if (data !== undefined) {
            let selectedIds = []
            let selectedNames = []

            for (let i = 0; i < data.length; i++) {
                selectedIds.push(data[i].value)
            }

            for (let i = 0; i < data.length; i++) {
                selectedNames.push(data[i].label)
            }

            this.setState({
                vod_pgroups_cards: data === null ? null : selectedIds,
            });
        }
    }

    handleChildSVodPriceGroupsCodesSelected(data) {

        if (data !== undefined) {
            let selectedIds = []
            let selectedNames = []

            for (let i = 0; i < data.length; i++) {
                selectedIds.push(data[i].value)
            }

            for (let i = 0; i < data.length; i++) {
                selectedNames.push(data[i].label)
            }

            this.setState({
                vod_pgroups_codes: data === null ? null : selectedIds,
            });
        }
    }

    handleChildImageSelect(folder, filename, imagePosition) {

        if (imagePosition === "vodpackage_image") {
            this.setState({
                vodpackage_image_temp: filename !== null,
                vodpackage_image: filename,
                vodpackage_image_folder_temp: folder
            });
        }
        if (imagePosition === "vodpackage_inactive_image") {
            this.setState({
                vodpackage_inactive_image_temp: filename !== null,
                vodpackage_inactive_image: filename,
                vodpackage_inactive_image_folder_temp: folder
            });
        }

    }

    handleChildContentProviderSelect(data) {

        if (data !== undefined) {
            this.setState({
                user_content_provider: data === null ? null : data.value,
                assignedSvodInPackage:[]
            });
        }
    }

    handleSvodPackageTypeChange = (packageTypeDropDown) => {

        this.setState({
            packageTypeDropDown,
            vodpackage_type: packageTypeDropDown === null ? null : packageTypeDropDown.value
        });
        console.log(`Option selected:`, packageTypeDropDown);

    }

    handleSvodPackageChannelChange(selectedFromChild) {

        let selectedSvod = []

        if (selectedFromChild !== undefined !== null) {

            for (let i = 0; i < selectedFromChild.length; i++) {
                //console.log(selectedFromChild[i].toString())
                selectedSvod.push(selectedFromChild[i].toString())
            }
        }

        this.setState({assignedSvodInPackage: selectedSvod})
    }

    handleSvodPackageSeriesChange(selectedFromChild) {

        let selectedSeries = []

        if (selectedFromChild !== undefined !== null) {

            for (let i = 0; i < selectedFromChild.length; i++) {
                //console.log(selectedFromChild[i].toString())
                selectedSeries.push(selectedFromChild[i].toString())
            }
        }

        this.setState({assignedSeriesInPackage: selectedSeries})
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    handleSwitch(elem, state) {
        if (elem.props.name === 'statusSwitch') {
            this.setState({statusSwitch: state})
        }
        if (elem.props.name === 'expirySwitch') {
            this.setState({expirySwitch: state})
        }
        if (elem.props.name === 'adultSwitch') {
            this.setState({adultSwitch: state})
        }
        if (elem.props.name === 'trialSwitch') {
            this.setState({trialSwitch: state})
        }
        if (elem.props.name === 'creditCardSwitch') {
            if (state) {
                this.setState({creditCardSwitch: state})
            } else {
                this.setState({creditCardSwitch: state})
            }
        }

        if (elem.props.name === 'codeSwitch') {
            if (state) {
                this.setState({codeSwitch: state})
            } else {
                this.setState({codeSwitch: state})
            }
        }

        if (elem.props.name === 'accountSwitch') {
            if (state) {
                this.setState({accountSwitch: state})
            } else {
                this.setState({accountSwitch: state})
            }
        }

        if (elem.props.name === 'countryBlockSwitch') {
            this.setState({countryBlockSwitch: state})
        }

        if (elem.props.name === 'accessVisibilitySwitch') {
            this.setState({accessVisibilitySwitch: state})
        }
    }

    componentDidMount() {

        this.setState({_notificationSystem: this.refs.notificationSystem})

        const {handle} = this.props.match.params

        if (handle === 'new') {
            let user = JSON.parse(localStorage.getItem('user'));
            this.setState({loading: false, newPackage: false, current_user: user})

        } else {

            this.setState({loading: true})
            const url = process.env.REACT_APP_API_URL + "/PackageSvod/" + handle;

            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {'X-Id-Token': token}
            };

            apiClient.get(url, axiosConfig)
                .then(res => {

                    const svodPackageObject = res.data[0];
                    const loading = false;

                    let selectedContent = []

                    if (svodPackageObject.vodpackage_assigned_content !== null) {
                        selectedContent = svodPackageObject.vodpackage_assigned_content.toString().split(",")
                    } else {
                        selectedContent = []
                    }

                    let selectedSeriesContent = []

                    if (svodPackageObject.vodpackage_assigned_series_content !== null) {
                        selectedSeriesContent = svodPackageObject.vodpackage_assigned_series_content.toString().split(",")
                    } else {
                        selectedSeriesContent = []
                    }

                    let groupCardIds = []

                    if (svodPackageObject.vodpackage_pgroups_cards !== null) {
                        let temp = svodPackageObject.vodpackage_pgroups_cards.toString();
                        groupCardIds = temp.split(",")
                    }

                    let groupCodeIds = []

                    if (svodPackageObject.vodpackage_pgroups_codes !== null) {
                        let temp = svodPackageObject.vodpackage_pgroups_codes.toString();
                        groupCodeIds = temp.split(",")
                    }

                    let countriesBlocked = []
                    if (svodPackageObject.vodpackage_country_block_countries !== null) {
                        let tempCountry = svodPackageObject.vodpackage_country_block_countries.toString();
                        countriesBlocked = tempCountry.split(",")
                    }

                    let status = svodPackageObject.vodpackage_status === 1
                    let adultSwitch = svodPackageObject.vodpackage_is_adult === 1
                    let expirySwitch = svodPackageObject.vodpackage_no_expiry === 1
                    let trialSwitch = svodPackageObject.vodpackage_trial === 1
                    let creditCardSwitch = svodPackageObject.vodpackage_credit_card_status ===1
                    let codeSwitch = svodPackageObject.vodpackage_code_status  ===1
                    let accountSwitch = svodPackageObject.vodpackage_account_status === 1
                    let countryBlockSwitch = svodPackageObject.vodpackage_country_block_status  === 1
                    let accessVisibilitySwitch = svodPackageObject.vodpackage_access_visibility  === 1

                    this.setState({
                        back_button_text: "Back",
                        vodpackage_id: svodPackageObject.vodpackage_id,
                        vodpackage_name_short: svodPackageObject.vodpackage_name_short,
                        vodpackage_name_long: svodPackageObject.vodpackage_name_long,
                        vodpackage_description: svodPackageObject.vodpackage_description,
                        vodpackage_status: svodPackageObject.vodpackage_status,
                        vodpackage_type: svodPackageObject.vodpackage_type,
                        vodpackage_price: svodPackageObject.vodpackage_price,
                        vodpackage_image: svodPackageObject.vodpackage_image,
                        vodpackage_inactive_image: svodPackageObject.vodpackage_inactive_image,
                        vodpackage_is_adult: svodPackageObject.vodpackage_is_adult,
                        vodpackage_display_while_inactive: svodPackageObject.vodpackage_display_while_inactive,
                        vodpackage_billing_code: svodPackageObject.vodpackage_billing_code,
                        vodpackage_subscription_url: svodPackageObject.vodpackage_subscription_url,
                        vodpackage_trial: trialSwitch,
                        vodpackage_duration: svodPackageObject.vodpackage_duration,
                        statusSwitch: status,
                        assignedSvodInPackage: selectedContent,
                        assignedSeriesInPackage: selectedSeriesContent,
                        adultSwitch,
                        expirySwitch,
                        loading,
                        trialSwitch,
                        svodPackageObject,
                        creditCardSwitch,
                        codeSwitch,
                        accountSwitch,
                        countryBlockSwitch,
                        accessVisibilitySwitch,
                        current_user: user,
                        user_content_provider: svodPackageObject.vodpackage_content_provider,
                        custom_data: svodPackageObject.custom_data,

                        vodpackage_credit_card_status: creditCardSwitch,
                        vodpackage_credit_card_product_id: svodPackageObject.vodpackage_credit_card_product_id,
                        vodpackage_credit_card_control_text: svodPackageObject.vodpackage_credit_card_control_text,
                        vodpackage_credit_card_help_url: svodPackageObject.vodpackage_credit_card_help_url,
                        vodpackage_code_status: codeSwitch,
                        vodpackage_code_control_text: svodPackageObject.vodpackage_code_control_text,
                        vodpackage_code_help_url: svodPackageObject.vodpackage_code_help_url,
                        vodpackage_account_status: accountSwitch,
                        vodpackage_account_control_text: svodPackageObject.vodpackage_account_control_text,
                        vodpackage_account_help_url: svodPackageObject.vodpackage_account_help_url,
                        vod_pgroups_codes: groupCodeIds,
                        vod_pgroups_cards: groupCardIds,

                        vodpackage_country_block_countries: countriesBlocked,
                        vodpackage_device_type_visibility: svodPackageObject.vodpackage_device_type_visibility,

                    });
                })
                .catch(error => {
                    this.setState({loading: false});
                    console.log(error);
                    //this.props.dispatch(userActions.logoutUnauthorized());
                });
        }
    }

    updateSvodPackage() {

        this.setState({loading: true})

        const {handle} = this.props.match.params
        const url = process.env.REACT_APP_API_URL + "/PackageSvod/" + handle;

        let status = this.state.statusSwitch === false ? 0 : 1
        let adultSwitch = this.state.adultSwitch === false ? 0 : 1
        let expirySwitch = this.state.expirySwitch === false ? 0 : 1
        let trialSwitch = this.state.trialSwitch === false ? 0 : 1
        let creditCardSwitch = this.state.creditCardSwitch === false ? 0 : 1
        let codeSwitch = this.state.codeSwitch === false ? 0 : 1
        let accountSwitch = this.state.accountSwitch === false ? 0 : 1
        let countryBlockStatus = this.state.countryBlockSwitch === false ? 0 : 1

        let contentInPackage = []

        for (let i = 0; i < this.state.assignedSvodInPackage.length; i++) {
            contentInPackage.push(this.state.assignedSvodInPackage[i])
        }

        let seriesContentInPackage = []

        for (let i = 0; i < this.state.assignedSeriesInPackage.length; i++) {
            seriesContentInPackage.push(this.state.assignedSeriesInPackage[i])
        }

        //RENAME FUNCTIONS START IMAGE ACTIVE
        let filename_active = ""

        if (this.state.vodpackage_image_temp) {
            let timeUTC = new Date().getTime()
            filename_active = timeUTC + "_" + this.state.vodpackage_image
            this.setState({vodpackage_image: filename_active})
            console.log("*****" + filename_active)
            this.submitActiveImage(filename_active);
        } else {
            filename_active = this.state.vodpackage_image
        }

        //RENAME FUNCTIONS START IMAGE INACTIVE
        let filename_inactive = ""

        if (this.state.vodpackage_inactive_image_temp) {
            let timeUTC = new Date().getTime()
            filename_inactive = timeUTC + "_" + this.state.vodpackage_inactive_image
            this.setState({vodpackage_inactive_image: filename_inactive})
            console.log("*****" + filename_inactive)
            this.submitInactiveImage(filename_inactive);
        } else {
            filename_inactive = this.state.vodpackage_inactive_image
        }

        // Send a PUT request
        var postData = {
            svod_package: {
                vodpackage_id: this.state.vodpackage_id,
                vodpackage_name_short: this.state.vodpackage_name_short,
                vodpackage_name_long: this.state.vodpackage_name_long,
                vodpackage_description: this.state.vodpackage_description,
                vodpackage_status: status,
                vodpackage_type: this.state.vodpackage_type,
                vodpackage_price: this.state.vodpackage_price,
                vodpackage_image: filename_active,
                vodpackage_inactive_image: filename_inactive,
                vodpackage_is_adult: adultSwitch,
                vodpackage_no_expiry: expirySwitch,
                vodpackage_display_while_inactive: null,
                vodpackage_billing_code: this.state.vodpackage_billing_code,
                vodpackage_subscription_url: this.state.vodpackage_subscription_url,
                vodpackage_trial: trialSwitch,
                vodpackage_duration: this.state.vodpackage_duration,
                vodpackage_assigned_content: contentInPackage.join(),
                vodpackage_assigned_series_content: seriesContentInPackage.join(),
                vodpackage_content_provider: this.state.user_content_provider,
                custom_data: this.state.custom_data,

                vodpackage_credit_card_status:  creditCardSwitch,
                vodpackage_credit_card_product_id:  this.state.vodpackage_credit_card_product_id,
                vodpackage_credit_card_control_text:  this.state.vodpackage_credit_card_control_text,
                vodpackage_credit_card_help_url:  this.state.vodpackage_credit_card_help_url,
                vodpackage_code_status:  codeSwitch,
                vodpackage_code_control_text:  this.state.vodpackage_code_control_text,
                vodpackage_code_help_url:  this.state.vodpackage_code_help_url,
                vodpackage_account_status:  accountSwitch,
                vodpackage_access_visibility: this.state.accessVisibilitySwitch === false ? 0 : 1,
                vodpackage_account_control_text:  this.state.vodpackage_account_control_text,
                vodpackage_account_help_url:  this.state.vodpackage_account_help_url,
                vodpackage_pgroups_codes: this.state.vod_pgroups_codes!== null ? this.state.vod_pgroups_codes.join() : null,
                vodpackage_pgroups_cards: this.state.vod_pgroups_cards !== null ? this.state.vod_pgroups_cards.join() : null,

                vodpackage_country_block_status: countryBlockStatus,
                vodpackage_country_block_countries: this.state.vodpackage_country_block_countries === null ? null : this.state.vodpackage_country_block_countries.join(','),
                vodpackage_device_type_visibility: Array.isArray(this.state.vodpackage_device_type_visibility) ? this.state.vodpackage_device_type_visibility.join(',') : null,
            }
        };

        console.log(postData)

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        apiClient.put(url, postData, axiosConfig)
            .then((res) => {

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    this.setState({loading: false})
                    this.notification("success")
                }

            })
            .catch((err) => {
                console.log("ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    createSvodPackage() {

        this.setState({loading: true})

        const url = process.env.REACT_APP_API_URL + "/PackageSvod";

        let contentInPackage = []

        for (let i = 0; i < this.state.assignedSvodInPackage.length; i++) {
            contentInPackage.push(this.state.assignedSvodInPackage[i])
        }

        let seriesContentInPackage = []

        for (let i = 0; i < this.state.assignedSeriesInPackage.length; i++) {
            seriesContentInPackage.push(this.state.assignedSeriesInPackage[i])
        }

        let status = this.state.statusSwitch === false ? 0 : 1
        let adultSwitch = this.state.adultSwitch === false ? 0 : 1
        let expirySwitch = this.state.expirySwitch === false ? 0 : 1
        let trialSwitch = this.state.trialSwitch === false ? 0 : 1
        let creditCardSwitch = this.state.creditCardSwitch === false ? 0 : 1
        let codeSwitch = this.state.codeSwitch === false ? 0 : 1
        let accountSwitch = this.state.accountSwitch === false ? 0 : 1
        let countryBlockStatus = this.state.countryBlockSwitch === false ? 0 : 1

        //RENAME FUNCTIONS START IMAGE ACTIVE
        let filename_active = ""

        if (this.state.vodpackage_image_temp) {
            let timeUTC = new Date().getTime()
            filename_active = timeUTC + "_" + this.state.vodpackage_image
            this.setState({vodpackage_image: filename_active})
            console.log("*****" + filename_active)
            this.submitActiveImage(filename_active);
        } else {
            filename_active = this.state.vodpackage_image
        }

        //RENAME FUNCTIONS START IMAGE INACTIVE
        let filename_inactive = ""

        if (this.state.vodpackage_inactive_image_temp) {
            let timeUTC = new Date().getTime()
            filename_inactive = timeUTC + "_" + this.state.vodpackage_inactive_image
            this.setState({vodpackage_inactive_image: filename_inactive})
            console.log("*****" + filename_inactive)
            this.submitInactiveImage(filename_inactive);
        } else {
            filename_inactive = this.state.vodpackage_inactive_image
        }

        var postData = {
            svod_package: {
                vodpackage_name_short: this.state.vodpackage_name_short,
                vodpackage_name_long: this.state.vodpackage_name_long,
                vodpackage_description: this.state.vodpackage_description,
                vodpackage_status: status,
                vodpackage_type: this.state.vodpackage_type,
                vodpackage_price: this.state.vodpackage_price,
                vodpackage_image: filename_active,
                vodpackage_inactive_image: filename_inactive,
                vodpackage_is_adult: adultSwitch,
                vodpackage_no_expiry: expirySwitch,
                vodpackage_trial: trialSwitch,
                vodpackage_display_while_inactive: null,
                vodpackage_billing_code: this.state.vodpackage_billing_code,
                vodpackage_assigned_content: contentInPackage.join(),
                vodpackage_assigned_series_content: seriesContentInPackage.join(),
                vodpackage_subscription_url: this.state.vodpackage_subscription_url,
                vodpackage_duration: this.state.vodpackage_duration,
                vodpackage_content_provider: this.state.user_content_provider,
                custom_data: this.state.custom_data,

                vodpackage_credit_card_status:  creditCardSwitch,
                vodpackage_credit_card_product_id:  this.state.vodpackage_credit_card_product_id,
                vodpackage_credit_card_control_text:  this.state.vodpackage_credit_card_control_text,
                vodpackage_credit_card_help_url:  this.state.vodpackage_credit_card_help_url,
                vodpackage_code_status:  codeSwitch,
                vodpackage_code_control_text:  this.state.vodpackage_code_control_text,
                vodpackage_code_help_url:  this.state.vodpackage_code_help_url,
                vodpackage_account_status:  accountSwitch,
                vodpackage_access_visibility: this.state.accessVisibilitySwitch === false ? 0 : 1,
                vodpackage_account_control_text:  this.state.vodpackage_account_control_text,
                vodpackage_account_help_url:  this.state.vodpackage_account_help_url,
                vodpackage_pgroups_codes: this.state.vod_pgroups_codes!== null ? this.state.vod_pgroups_codes.join() : null,
                vodpackage_pgroups_cards: this.state.vod_pgroups_cards !== null ? this.state.vod_pgroups_cards.join() : null,

                vodpackage_country_block_status: countryBlockStatus,
                vodpackage_country_block_countries: this.state.vodpackage_country_block_countries === null ? null : this.state.vodpackage_country_block_countries.join(','),
                vodpackage_device_type_visibility: Array.isArray(this.state.vodpackage_device_type_visibility) ? this.state.vodpackage_device_type_visibility.join(',') : null,
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        apiClient.post(url, postData, axiosConfig)
            .then((res) => {
                this.setState({loading: false})

                if (res.data.error === 301) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else if (res.data.error === 302) {
                    this.setState({
                        loading: false
                    })
                    this.notification("failed")
                } else {
                    const svodPackageObject = res.data;
                    this.setState({vodpackage_id: svodPackageObject.vodpackage_id})
                    this.setSvodPackageRedirect();
                    this.notification("success")
                }
            })
            .catch((err) => {
                console.log("ERROR: ", err);
                this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    submitActiveImage(filename_active) {

        const imageUploadUrl = process.env.REACT_APP_IMAGE_SUBMIT_API_URL;

        if (this.state.vodpackage_image_temp) {

            let bodyFormData = new FormData();
            bodyFormData.set('filepond[]', this.state.vodpackage_image_folder_temp);
            bodyFormData.set('location', "package_svod");
            bodyFormData.set('filename', filename_active);

            apiClient.post(imageUploadUrl, bodyFormData)
                .then((res) => {
                    this.setState({vodpackage_image_temp: false})
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })
        }

    }

    submitInactiveImage(filename_inactive) {

        const imageUploadUrl = process.env.REACT_APP_IMAGE_SUBMIT_API_URL;

        if (this.state.vodpackage_inactive_image_temp) {

            let bodyFormData = new FormData();
            bodyFormData.set('filepond[]', this.state.vodpackage_inactive_image_folder_temp);
            bodyFormData.set('location', "package_svod");
            bodyFormData.set('filename', filename_inactive);


            apiClient.post(imageUploadUrl, bodyFormData)
                .then((res) => {
                    this.setState({vodpackage_inactive_image_temp: false})
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })
        }

    }

    setSaveModal = (value, action) => {

        this.setState({
            showSaveModal: value

        })

        if (action === "save") {
            this.setState({loading: true})

            const {handle} = this.props.match.params

            if (handle === 'new') {
                this.createSvodPackage();
            } else {
                this.updateSvodPackage();
            }
        }
    }

    cancelSvodPackageEdit() {
        this.setRedirect();
    }

    setSvodPackageRedirect = () => {
        this.setState({
            vodPackageRedirect: true,
            back_button_text: "Back"
        })
    }

    renderSaveModal = () => {

        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"SVOD Package: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.vodpackage_id === 0 ? '' : this.state.vodpackage_id}
            />
        }

    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        let path = "/packages/svod-package";
        let pathvodpackage = "/edit-svod-package/" + this.state.vodpackage_id;

        if (this.state.redirect) {
            return <Redirect push to={path}/>
        }

        if (this.state.vodPackageRedirect) {

            this.setState({
                vodPackageRedirect: false,
                redirect: false
            })

            return <Redirect push to={pathvodpackage}/>
        }

    }

    renderSelection = () => {

        if (this.state.vodpackage_type === 'SERIES') {
            return (
                <Card
                    content={
                        <div>
                            <h5>Series Selection</h5>
                            <legend/>
                            <Grid fluid>
                                <Row>
                                    <DualListBoxPackageSvodSeries
                                        seriesInPackage={this.state.assignedSvodInPackage}
                                        packageID={this.state.vodpackage_id}
                                        packageType={"SERIES"}
                                        handlerFromParent={this.handleSvodPackageChannelChange}
                                        svodPackageSeriesProvider={this.state.user_content_provider}
                                    />
                                </Row>
                            </Grid>
                        </div>
                    }
                />
            )
        }

        if (this.state.vodpackage_type === 'MOVIES') {
            return (
                <Card
                    content={
                        <div>
                            <h5>Movies Selection</h5>
                            <legend/>
                            <Grid fluid>
                                <Row>
                                    <DualListBoxPackageSvodMovies
                                        moviesInPackage={this.state.assignedSvodInPackage}
                                        packageID={this.state.vodpackage_id}
                                        packageType={"MOVIES"}
                                        handlerFromParent={this.handleSvodPackageChannelChange}
                                        svodPackageMoviesProvider={this.state.user_content_provider}
                                    />
                                </Row>
                            </Grid>
                        </div>
                    }
                />
            )
        }

        if (this.state.vodpackage_type === 'SELECTED') {
            return (
                <div>
                    <Card
                        content={
                            <div>
                                <h5>Movies Selection</h5>
                                <legend/>
                                <Grid fluid>
                                    <Row>
                                        <DualListBoxPackageSvodMovies
                                            moviesInPackage={this.state.assignedSvodInPackage}
                                            packageID={this.state.vodpackage_id}
                                            packageType={"MOVIES"}
                                            handlerFromParent={this.handleSvodPackageChannelChange}
                                            svodPackageMoviesProvider={this.state.user_content_provider}
                                        />
                                    </Row>
                                </Grid>
                            </div>
                        }
                    />

                    <Card
                        content={
                            <div>
                                <h5>Series Selection</h5>
                                <legend/>
                                <Grid fluid>
                                    <Row>
                                        <DualListBoxPackageSvodSeries
                                            seriesInPackage={this.state.assignedSeriesInPackage}
                                            packageID={this.state.vodpackage_id}
                                            packageType={"SERIES"}
                                            handlerFromParent={this.handleSvodPackageSeriesChange}
                                            svodPackageSeriesProvider={this.state.user_content_provider}
                                        />
                                    </Row>
                                </Grid>
                            </div>
                        }
                    />

                </div>


            )


        }
    }

    renderDurationFields = () => {

        if (!this.state.expirySwitch) {
            return (
                <FormGroup>
                    <ControlLabel>Duration (Days)</ControlLabel>
                    <FormControl placeholder="Enter the duration"
                                 type="number"
                                 name={"vodpackage_duration"}
                                 disabled={this.state.loading}
                                 onChange={this.handleInputChange}
                                 value={this.state.vodpackage_duration || ""}/>
                </FormGroup>
            );
        }


    }

    notification(status) {

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>SVOD Package has been updated</b>
                    </div>
                ),
                level: 'success',
                position: 'tr',
                autoDismiss: 5,
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>failed to update SVOD Package</b>
                    </div>
                ),
                level: 'error',
                position: 'tr',
                autoDismiss: 10,
            });
        }

    }

    renderContentProvider = () => {

        if (this.state.current_user) {
            if (adminArray.includes(this.state.current_user.level)) {
                return (
                    <FormGroup>
                        <ControlLabel>Content Provider</ControlLabel>
                        <DropDownContentProviders
                            contentProviderSelected={this.state.user_content_provider}
                            name='contentProviderSelect'
                            handlerFromParent={this.handleChildContentProviderSelect}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                )
            }
        }

    }

    onClickAddAllCountriesCountryBlock() {

        this.setState({addAllCountriesInCountryBlock: true})

    }

    handleChildCountryBlockSelect(data) {

        let countryIDs = []
        let countryNames = []

        for (let i = 0; i < data.length; i++) {
            countryIDs.push(data[i].value)
        }

        for (let i = 0; i < data.length; i++) {
            countryNames.push(data[i].label)
        }

        //console.log(data);
        this.setState({
            vodpackage_country_block_countries: data === null ? 0 : countryIDs, addAllCountriesInCountryBlock: false
        });
    }

    renderCountryBlockFields = () => {

        if (this.state.countryBlockSwitch) {
            return (
                <div>
                    <FormGroup>
                        <ControlLabel>Countries to block</ControlLabel>
                        <DropDownCountries
                            countrySelected={this.state.vodpackage_country_block_countries}
                            name='countryBlockSelect'
                            handlerFromParent={this.handleChildCountryBlockSelect}
                            hadlerAddAllCountries={this.state.addAllCountriesInCountryBlock}
                        />
                    </FormGroup>

                    <FormGroup>
                        <Button
                            onClick={this.onClickAddAllCountriesCountryBlock.bind(this)}
                        >
                            Add All countries
                        </Button>
                    </FormGroup>

                    <Well><Glyphicon glyph="question-sign"/> By enabling the Country Block
                        functionality,the live channels will be hidden for the countries specified.
                    </Well>
                </div>
            );
        }
    }

    renderCreditCardFields = () => {


        if (this.state.creditCardSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Credit Card Control Text</ControlLabel>
                        <FormControl placeholder="Enter credit card control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_credit_card_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_credit_card_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Credit Card product ID</ControlLabel>
                        <FormControl placeholder="Enter credit card product id"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_credit_card_product_id"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_credit_card_product_id || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Credit Card Help URL</ControlLabel>
                        <FormControl placeholder="Enter credit card help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_credit_card_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_credit_card_help_url || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Card price groups</ControlLabel>
                        <DropDownSvodPriceList
                            priceGroupsSelected={this.state.vod_pgroups_cards}
                            name='vodCardPriceGroupsSelected'
                            handlerFromParent={this.handleChildSVodPriceGroupsCreditCardSelected}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    renderCodeFields = () => {


        if (this.state.codeSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Code Control Text</ControlLabel>
                        <FormControl placeholder="Enter code control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_code_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_code_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Code Help URL</ControlLabel>
                        <FormControl placeholder="Enter code help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_code_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_code_help_url || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Code price groups</ControlLabel>
                        <DropDownSvodPriceList
                            priceGroupsSelected={this.state.vod_pgroups_codes}
                            name='vodCodePriceGroupsSelected'
                            handlerFromParent={this.handleChildSVodPriceGroupsCodesSelected}
                            disabled={this.state.loading}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    renderAccountFields = () => {

        if (this.state.accountSwitch) {
            return (
                <div>

                    <FormGroup>
                        <ControlLabel>Account Control Text</ControlLabel>
                        <FormControl placeholder="Enter account control text"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_account_control_text"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_account_control_text || ""}
                        />
                    </FormGroup>

                    <FormGroup>
                        <ControlLabel>Account Help URL</ControlLabel>
                        <FormControl placeholder="Enter account help url"
                                     type="text"
                                     disabled={this.state.loading}
                                     name="vodpackage_account_help_url"
                                     onChange={this.handleInputChange}
                                     value={this.state.vodpackage_account_help_url || ""}
                        />
                    </FormGroup>

                </div>
            );
        }
    }

    render() {
        return (
            <div className="main-content">

                <NotificationSystem ref="notificationSystem" style={style}/>

                {this.renderRedirect()}
                {this.renderSaveModal()}

                <div className="sweet-loader">
                    <ScaleLoader
                        css={override}
                        color={'#797979'}
                        loading={this.state.loading}
                        //loading={true}
                    />
                </div>

                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                content={
                                    <div>
                                        <h5>SVOD Package Information</h5>
                                        <legend/>

                                        <FormGroup>
                                            <Row>
                                                <Col md={3}>
                                                    <ControlLabel>Status</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"statusSwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.statusSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>No Expiry</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"expirySwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.expirySwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>Trial</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"trialSwitch"}
                                                        disabled={this.state.loading || this.state.expirySwitch}
                                                        value={this.state.trialSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <ControlLabel>Adult</ControlLabel>
                                                    <br/>
                                                    <Switch
                                                        name={"adultSwitch"}
                                                        disabled={this.state.loading}
                                                        value={this.state.adultSwitch}
                                                        onChange={(el, state) => this.handleSwitch(el, state)}
                                                    />
                                                </Col>
                                            </Row>
                                        </FormGroup>


                                        <FormGroup>
                                            <ControlLabel>Package Type</ControlLabel>
                                            <Select
                                                value={this.state.vodpackage_type}
                                                onChange={this.handleSvodPackageTypeChange}
                                                options={packageType}
                                                disabled={this.state.newPackage}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Short Name</ControlLabel>
                                            <FormControl placeholder="Enter Short Name"
                                                         type="text"
                                                         name={"vodpackage_name_short"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.vodpackage_name_short || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Reference ID</ControlLabel>
                                            <FormControl placeholder="Enter the price"
                                                         type="text"
                                                         name={"vodpackage_billing_code"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.vodpackage_billing_code || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Price</ControlLabel>
                                            <FormControl placeholder="Enter the price"
                                                         type="number"
                                                         name={"vodpackage_price"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.vodpackage_price || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>External URL</ControlLabel>
                                            <InputGroup>
                                                <InputGroup.Addon style={{backgroundColor: "lightgray"}}>
                                                    <Glyphicon glyph="globe"/>
                                                </InputGroup.Addon>
                                                <FormControl
                                                    placeholder={this.props.t('packages_svod_edit.vodpackage_subscription_url_placeholder', {framework: "react-i18next"})}
                                                    type="text"
                                                    name="vodpackage_subscription_url"
                                                    disabled={this.state.loading}
                                                    onChange={this.handleInputChange}
                                                    value={this.state.vodpackage_subscription_url || ""}
                                                />
                                            </InputGroup>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Long Name</ControlLabel>
                                            <FormControl placeholder="Enter Long Name"
                                                         type="text"
                                                         name={"vodpackage_name_long"}
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         value={this.state.vodpackage_name_long || ""}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Description</ControlLabel>
                                            <FormControl componentClass="textarea"
                                                         type="text"
                                                         rows={4}
                                                         name="vodpackage_description"
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         placeholder="Enter the description"
                                                         value={this.state.vodpackage_description || ""}
                                            />
                                        </FormGroup>

                                        {this.renderDurationFields()}

                                        {this.renderContentProvider()}

                                        <FormGroup>
                                            <ControlLabel>Access Visibility</ControlLabel>
                                            <br/>
                                            <Switch
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                                name='accessVisibilitySwitch'
                                                disabled={this.state.loading}
                                                value={this.state.accessVisibilitySwitch}
                                                defaultValue={false}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Device Type Visibility</ControlLabel>
                                            <Select
                                                value={this.state.vodpackage_device_type_visibility}
                                                onChange={this.handleDeviceTypeChange}
                                                options={DeviceTypeOptions}
                                                multi={true}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>Country Block</ControlLabel>
                                            <br/>
                                            <Switch
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                                name='countryBlockSwitch'
                                                disabled={this.state.loading}
                                                value={this.state.countryBlockSwitch}
                                                defaultValue={false}
                                            />
                                        </FormGroup>

                                        {this.renderCountryBlockFields()}

                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Credit Card</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='creditCardSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.creditCardSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderCreditCardFields()}
                                        </div>

                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Codes</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='codeSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.codeSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderCodeFields()}
                                        </div>

                                        <div>
                                            <br/>
                                            <legend/>
                                            <ControlLabel>Account</ControlLabel>
                                            <FormGroup>
                                                <Switch
                                                    onChange={(el, state) => this.handleSwitch(el, state)}
                                                    name='accountSwitch'
                                                    disabled={this.state.loading}
                                                    value={this.state.accountSwitch}
                                                    defaultValue={false}
                                                />
                                            </FormGroup>
                                            {this.renderAccountFields()}
                                        </div>

                                    </div>
                                }
                                ftTextCenter
                                legend={
                                    <div className="buttons-with-margin">
                                        <Button bsStyle="info" fill wd
                                                name={"saveButton"}
                                                disabled={this.state.loading}
                                                onClick={() => this.setState({showSaveModal: true})}
                                        >
                                            Save
                                        </Button>
                                        <Button bsStyle="default" fill wd
                                                name={"cancelButton"}
                                                disabled={this.state.loading}
                                                onClick={this.cancelSvodPackageEdit.bind(this)}>
                                            {this.state.back_button_text}
                                        </Button>
                                    </div>
                                }
                            />
                        </Col>

                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                content={
                                    <div>
                                        <h5>Assets</h5>
                                        <legend/>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={6}>
                                                    <div className="text-center">
                                                        <p>Active</p>
                                                    </div>
                                                    <ImageUpload
                                                        imageName={this.state.vodpackage_image}
                                                        imageType="package_svod"
                                                        imagePosition={"vodpackage_image"}
                                                        imageTemp={this.state.vodpackage_image_temp}
                                                        imageFolderTemp={this.state.vodpackage_image_folder_temp}
                                                        handlerFromParent={this.handleChildImageSelect}
                                                    />
                                                </Col>
                                                <Col md={6}>
                                                    <div className="text-center">
                                                        <p>Inactive</p>
                                                    </div>
                                                    <ImageUpload
                                                        imageName={this.state.vodpackage_inactive_image}
                                                        imageType="package_svod"
                                                        imagePosition={"vodpackage_inactive_image"}
                                                        imageTemp={this.state.vodpackage_inactive_image_temp}
                                                        imageFolderTemp={this.state.vodpackage_inactive_image_folder_temp}
                                                        handlerFromParent={this.handleChildImageSelect}
                                                    />
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>


                        <Col xs={12} sm={12} md={12} lg={6}>
                            {this.renderSelection()}
                        </Col>

                    </Row>
                </Grid>


            </div>
        );
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedEditPackagesSvod = connect(mapStateToProps)(EditPackagesSvod);
const connectedEditPackagesSvodTrans = withNamespaces('common')(connectedEditPackagesSvod);
export {connectedEditPackagesSvodTrans as EditPackagesSvod};
